import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ae8aeba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col space-y-2" }
const _hoisted_2 = { class: "p-1 rounded-full custom-bg" }
const _hoisted_3 = ["name", "placeholder", "id", "required", "value", "type"]

import { computed, Ref, ref } from "vue";
import LabelBase from "@/components/Texts/LabelBase.vue";
import TextError from "@/components/Texts/TextError.vue";
import { useErrorsStore } from "@/store/useErrorsStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
    name: {},
    placeholder: {},
    id: {},
    is_required: { type: Boolean },
    modelValue: {},
    type: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const errorsStore = useErrorsStore();

const props = __props;

const errorMessage = computed(() => {
  if (props.error) {
    const errorInput = errorsStore.getErrorByName(props.error);
    if (errorInput) {
      return errorInput.message;
    }
  }
  return "";
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LabelBase, {
      text: props.placeholder
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        name: props.name,
        placeholder: props.placeholder,
        id: props.id,
        required: props.is_required,
        value: _ctx.modelValue,
        type: props.type,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)
        )),
        class: "bg-custom-primaryBlack text-white rounded-full px-5 py-3 w-full"
      }, null, 40, _hoisted_3)
    ]),
    (props.error && errorMessage.value)
      ? (_openBlock(), _createBlock(TextError, {
          key: 0,
          text: errorMessage.value
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})